import React, { useState , useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import leaderImage from '../img/envision/Leadershipo/1706554620347.jpg';  // Import the image file
import BoardOfDirectorsnavbar from './BoardOfDirectorsnavbar';
import { FaLinkedin } from 'react-icons/fa';
import AboutLeadershipsecondcontainer from './AboutLeadershipsecondcontainer';
import Footer from './Footer'
import { Link } from 'react-router-dom';
const Leadershipdatatwo = () => {
     const location = useLocation();
    
        useEffect(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, [location]); // Run effect when the route changes
        
    return (
        <div>
            <div style={{ background: "rgb(254 153 0)", marginTop: "80px", height: "63px" }}>
                <h1 style={{ textAlign: "center", paddingTop: "13px" }}>OUR LEADERSHIP</h1>
            </div>
            {/* <BoardOfDirectorsnavbar />    */}
            <div style={styles.rowWrapper}>

                <div style={styles.row}>
                    <div style={styles.widgetSpan}>
                        <div id="hs_cos_wrapper_module_1564397675620228" style={styles.hsCosWrapper}>
                            {/* LazySizes Script */}
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js" async=""></script>

                            <div style={styles.abMembers}>
                                <div style={styles.container}>
                                    <div style={styles.imageColumn}>
                                        <div style={styles.mImage}>
                                            {/* Use the imported image */}
                                            <img
                                                className="ls-is-cached lazyloaded"
                                                src={leaderImage}  
                                                alt="Raghuram Prasad K"
                                                style={styles.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={styles.textColumn}>
                                        <h1>Raghuram Prasad K </h1>
                                        <span> Founder & CEO</span>
                                        <br />

                                        {/* LinkedIn Icon */}
                                        <a href="https://www.linkedin.com/in/raghuram-prasad-k-30616645/" target="_blank" rel="noopener noreferrer">
                                            <FaLinkedin size={30} color="#0077B5" />
                                        </a>

                                    </div>
                                </div>
                            </div>

                            <div style={styles.memberParagraph}>
                                <div style={styles.container}>
                                    <div style={styles.col12}>
                                        <div style={styles.teamParagraph}>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' }}>Raghuram Prasad K – Founder & CEO, DREBCON </p>
                                            
                                            <p style={{ textAlign: 'justify', marginTop:'10px' }}>
                                            With over two decades of experience in IT security, governance, risk, and compliance (GRC), Raghuram Prasad K has been at the forefront of cybersecurity, business resilience, and digital transformation. After leading global IT governance and risk programs for multinational organizations, he has now founded DREBCON, driven by grit, persistence, and a vision to redefine security, compliance, and risk management in the digital era. 

                                       As the Director – Global IT Risk & Governance at AVEVA, Schneider Electric for more than a decade, Raghuram played a pivotal role in establishing enterprise-wide IT governance frameworks, strengthening cybersecurity defences, and ensuring business continuity. His expertise spans NIST-aligned risk strategies, IT PMO frameworks, regulatory compliance, and enterprise risk management. 
                                            </p><br></br>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px',  }}>A Legacy of Leadership & Innovation  </p>
                                           
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>
                                            Before founding DREBCON and a decade of AVEVA experience, Raghuram held key positions in renowned organizations: 
                                            </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                <li style={{fontWeight:'bold'}}>Mindtree Ltd </li>
                                                <li style={{marginLeft:"30px"}}>Established the Risk & Compliance Centre of Excellence (RCoE). </li>
                                                <li style={{marginLeft:"30px"}}>Designed risk frameworks for BFSI, Energy and manufacturing sector clients. </li>
                                            </ul>

                                        
                                    
                                          <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                <li style={{fontWeight:'bold'}}>Royal Bank of Scotland  </li>
                                                <li style={{marginLeft:"30px"}}>Led finance and operational risk mitigation projects.  </li>
                                                <li style={{marginLeft:"30px"}}>Managed AML compliance and technology audits.  </li>
                                            </ul>
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                <li style={{fontWeight:'bold'}}>Thinksoft Global Services, BNP PARIBAS & FORTIS banks (Belgium)  </li>
                                                <li style={{marginLeft:"30px"}}>Delivered finance and risk compliance solutions for GE Swiss Bank, Morgan Stanley, BNP Paribas Fortis, and Misys.  </li>
                                               
                                            </ul>


                                         
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' , marginTop:'20px'}}>
                                            Academic & Professional Excellence 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>Raghuram holds an MBA from the Indian Institute of Management (IIM), Raipur, along with prestigious industry certifications, including: </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}><b>CRISC </b>(Certified in Risk and Information Systems Control)  </li>
                                                <li style={{marginLeft:"30px"}}><b>CISM </b>(Certified in Information security management) </li>
                                                <li style={{marginLeft:"30px"}}><b>PMP </b>(Project Management Professional) </li>

                                                <li style={{marginLeft:"30px"}}><b>AWS </b>(Certified Cloud Solutions Architect) </li>
                                                <li style={{marginLeft:"30px"}}><b>CBCP</b> (Certified Business Continuity Professional)  </li>

                                            </ul>

                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' , marginTop:'20px'}}>
                                            The Vision behind DREBCON  
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>DREBCON is the culmination of Raghuram’s unwavering dedication to IT security and risk management. His mission is to empower businesses with robust cybersecurity, governance, and compliance solutions, ensuring resilience in an increasingly complex digital landscape. Additionally, DREBCON is committed to driving GEN AI-enabled IT and OT transformation across diverse industries, leveraging cutting-edge artificial intelligence to enhance operational efficiencies, fortify security, and accelerate digital innovation.  </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>Beyond his professional achievements, he remains committed to thought leadership, capacity building, and driving innovation in the GRC and cybersecurity domains.  </p>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AboutLeadershipsecondcontainer />
            <Footer />
        </div>
    );
};

const styles = {
    rowWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '46px',
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
    },
    widgetSpan: {
        padding: '20px',
    },
    hsCosWrapper: {
        marginBottom: '30px',
    },
    abMembers: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
    },
    container: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    imageColumn: {
        flex: 1,
        paddingRight: '20px',
    },
    mImage: {
        width: '100%',
    },
    image: {
        width: '86%',
        borderRadius: '8px',
        border: '1px solid'
    },
    textColumn: {
        flex: 2,
        paddingLeft: '20px',
        display: 'flex',               // Add display flex to enable flexbox layout
        flexDirection: 'column',       // Arrange children in a column
        justifyContent: 'center',     // Vertically center the content
        // alignItems: 'center',        
        // textAlign: 'center',        
    },
    socialLink: {
        display: 'inline-block',
        marginTop: '10px',
    },
    socialIcon: {
        width: '30px',
        height: '30px',
    },
    memberParagraph: {
        padding: '20px',
    },
    col12: {
        width: '100%',
    },
    teamParagraph: {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#333',
        textAlign: 'justify',  // Added text alignment as justify
    },
};

export default Leadershipdatatwo;
